<template>
  <transition name="fade">
    <div class="modal-page-overlay">
      <transition name="modal">
        <div class="c-modal">
          <div class="card w-100">

            <!-- HEADER -->
            <div
              class="card-header"
              v-if="hasHeaderContent">
              <slot name="header" />
            </div>

            <!-- BODY (should have content) -->
            <div class="card-body">
              <slot />
            </div>

            <!-- FOOTER -->
            <div class="card-footer">

              <div v-if="hasFooterContent">
                <slot name="footer" />
              </div>

              <div v-else>
                <div class="float-lg-right">
                  <div
                    class="btn btn-secondary"
                    @click="$emit('close')">
                    <i class="fa fa-close" /> Close
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import OptionalSlots from '../mixins/OptionalSlotsMixin';

export default {
    mixins: [
        OptionalSlots,
    ],

    props: {
        id: {
            type: String,
            default: 'bootstrap-modal-' + (Math.floor(Math.random() * 1000))
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-page-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    background-color: rgba(96, 96, 96, 0.5);
    text-align: center;
}

.c-modal {
    position: relative;
    display: inline-block;
    width: 90%;
    max-width: 800px;
    vertical-align: middle;
    margin-top: 100px;
     & * {
       text-align: left;
     }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/common/ModalCard.vue